const svg = (path: string): string =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;

export const iconHome = (): string =>
  svg('<path d="M4 11.5 12 4l8 7.5"/><path d="M6.5 10.5V20h11V10.5"/>');

export const iconClients = (): string =>
  svg(
    '<circle cx="9" cy="8" r="3"/><circle cx="16.5" cy="9.5" r="2.4"/><path d="M3.5 19c.6-3 2.8-5 5.5-5s4.9 2 5.5 5"/><path d="M14 19c.3-1.7 1.4-3.2 3.2-3.8 1.6-.2 3 .7 3.8 2.2"/>',
  );

export const iconGlobe = (): string =>
  svg(
    '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.4 2.6 3.6 5.6 3.6 8.5S14.4 17.9 12 20.5C9.6 17.9 8.4 14.9 8.4 12S9.6 6.1 12 3.5z"/>',
  );

export const iconFolder = (): string =>
  svg('<path d="M3.5 7.5h6l1.6 2H20.5v9.5H3.5z"/><path d="M3.5 7.5V5.8c0-.7.6-1.3 1.3-1.3H9"/>');

export const iconSearch = (): string =>
  svg('<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/>');

export const iconSettings = (): string =>
  svg(
    '<circle cx="12" cy="12" r="3"/><path d="M12 3.5v2.2M12 18.3v2.2M4.8 6.5l1.6 1.6M17.6 15.9l1.6 1.6M3.5 12h2.2M18.3 12h2.2M4.8 17.5l1.6-1.6M17.6 8.1l1.6-1.6"/>',
  );

export const iconPlus = (): string => svg('<path d="M12 5v14M5 12h14"/>');

export const iconCalendar = (): string =>
  svg(
    '<rect x="3.5" y="5.5" width="17" height="15" rx="2"/><path d="M8 3.5v4M16 3.5v4M3.5 10h17"/>',
  );

export const iconActivity = (): string => svg('<path d="M3.5 12h4l2-6 5 12 2-6h4"/>');

export const iconSpark = (): string =>
  svg('<path d="M12 3.5 13.8 9H19.5l-4.4 3.3L16.8 18 12 14.7 7.2 18l1.7-5.7L4.5 9h5.7z"/>');

export const iconNote = (): string =>
  svg(
    '<path d="M6 4.5h9.5L19.5 8.5V19.5H6z"/><path d="M15.5 4.5V8.5H19.5"/><path d="M9 12h6M9 15.5h4"/>',
  );

export const iconInbox = (): string =>
  svg(
    '<path d="M3.5 13.5 6.2 5.5h11.6l2.7 8V19.5H3.5z"/><path d="M3.5 13.5h4.2l1.3 2.3h6l1.3-2.3h4.2"/>',
  );

export const iconLock = (): string =>
  svg(
    '<rect x="5.5" y="11" width="13" height="9" rx="1.8"/><path d="M8.2 11V8.2a3.8 3.8 0 0 1 7.6 0V11"/>',
  );

export const iconGauge = (): string =>
  svg(
    '<path d="M5.2 16.2a7.5 7.5 0 1 1 13.6 0"/><path d="M12 13.5 15.2 9.8"/><circle cx="12" cy="16.2" r="1.15"/>',
  );

export const iconUser = (): string =>
  svg('<circle cx="12" cy="8.2" r="3.1"/><path d="M5.2 19.2c.8-3.2 3.2-5 6.8-5s6 1.8 6.8 5"/>');

export const iconStar = (): string =>
  svg('<path d="M12 3.8 13.7 9h5.5l-4.4 3.2 1.7 5.4L12 14.6 7.5 17.6l1.7-5.4L4.8 9h5.5z"/>');

export const iconBuilding = (): string =>
  svg(
    '<path d="M5.5 20.5V6.2c0-.7.5-1.2 1.2-1.2h10.6c.7 0 1.2.5 1.2 1.2V20.5"/><path d="M3.5 20.5h17"/><path d="M9 8.5h1.5M13.5 8.5H15M9 12h1.5M13.5 12H15M9 15.5h1.5M13.5 15.5H15"/>',
  );

export const iconMapPin = (): string =>
  svg(
    '<path d="M12 20.5s6.2-5.2 6.2-10.1A6.2 6.2 0 0 0 5.8 10.4C5.8 15.3 12 20.5 12 20.5z"/><circle cx="12" cy="10.2" r="2.1"/>',
  );

export const iconCheck = (): string => svg('<path d="M5 12.5 10 17.5 19.5 7"/>');
